import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withCookies } from 'react-cookie'
import { Image } from '@sainsburys-tech/bolt'

import { AmplienceConfig, buildImageUrl, buildProductImageBaseUrl } from '../../helpers/amplienceHelper'

const getSource = props => buildImageUrl(props)

class ProductImage extends Component {
  render() {
    const { height, width, alt, partNumber, templateType } = this.props
    const imgUrl = buildProductImageBaseUrl(partNumber)
    const newProps = { ...this.props, imgUrl }
    const src = getSource(newProps)
    return <Image {...{ src, height, width, alt, templates: [templateType] }} />
  }
}

ProductImage.propTypes = {
  partNumber: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  templateType: PropTypes.string,
  sets: PropTypes.arrayOf(PropTypes.number),
  alt: PropTypes.string
}
ProductImage.defaultProps = {
  width: 100,
  height: 100,
  templateType: AmplienceConfig.imageTypes.ProductImageThumbnail.templateName,
  sets: [1, 2],
  alt: ''
}
export { ProductImage }
export default withCookies(ProductImage)
